import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { checkSuperuser } from "../api";
import SpinnerMain from "./Spinner";
const ProtectedSuperuserRoute = ({ children }) => {
    const [isSuperuser, setIsSuperuser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifySuperuser = async () => {
            try {
                const result = await checkSuperuser();
                setIsSuperuser(result.is_superuser);
            } catch (error) {
                console.error("Error verifying superuser:", error);
                setIsSuperuser(false);
            } finally {
                setLoading(false);
            }
        };

        verifySuperuser();
    }, []);

    if (loading) {
        return <SpinnerMain />; // Or a spinner component
    }

    if (!isSuperuser) {
        return (
            <Navigate
                to="/"
                replace
            />
        ); // Redirect to home or login page
    }

    return children;
};

export default ProtectedSuperuserRoute;
